/**
 * App.js
 * 
 * Este archivo configura las rutas principales de la aplicación utilizando React Router.
 * Importa los componentes necesarios y define las rutas de la aplicación.
 * 
 * Rutas:
 * - /: Renderiza el componente InicioSesion
 * - /inicio-sesion: Renderiza el componente InicioSesion
 * - /registro-sesion: Renderiza el componente RegistroSesion
 * - /boletines: Renderiza el componente Boletines
 * - /menus-comedor: Renderiza el componente MenusComedor
 * - /orla-colegial: Renderiza el componente OrlaColegial
 * - /pruebas: Renderiza el componente Pruebas
 * - /usuarios-admin: Renderiza el componente UsuariosAdmin
 * - /comunicados-oficiales: Renderiza el componente ComunicadosOficiales
 * - /pase-comidas: Renderiza el componente PaseComidas
 * - /mensajeria: Renderiza el componente Mensajeria
 * - /notificaciones: Renderiza el componente Notificaciones
 * 
 * Dependencias:
 * - react: Biblioteca de JavaScript para construir interfaces de usuario
 * - react-router-dom: Enrutamiento declarativo para aplicaciones React
 * - Estilos/App.css: Estilos globales para la aplicación
 * 
 * Notas:
 * - Se utiliza BrowserRouter con el alias Router para mayor comodidad.
 * - La prop element se utiliza para especificar el componente que se renderizará para cada ruta.
 * - Se utilizan convenciones de nombres y mayúsculas/minúsculas consistentes para las rutas.
 */

import React from 'react';
import {
  BrowserRouter,
  Route,
  Routes
} from 'react-router-dom';
import './Estilos/App.css';

import InicioSesion from './Paginas/InicioSesion';
import RegistroSesion from './Paginas/RegistroSesion';
import Boletines from './Paginas/Boletines';
import MenusComedor from './Paginas/MenusComedor';
import OrlaColegial from './Paginas/OrlaColegial';
import UsuariosAdmin from './Paginas/UsuariosAdmin';
import ComunicadosOficiales from './Paginas/ComunicadosOficiales';
import PaseComidas from './Paginas/PaseComidas';
import Mensajeria from './Paginas/Mensajeria';
import Notificaciones from './Paginas/Notificaciones';
import AjustesAdmin from './Paginas/AjustesAdmin';

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path= '/' Component={InicioSesion}/>     
      <Route path= '/InicioSesion' Component={InicioSesion} /> 
      <Route path= '/RegistroSesion' Component={RegistroSesion} />   
      <Route path= '/Boletines' Component={Boletines} />  
      <Route path= '/MenusComedor' Component={MenusComedor} />  
      <Route path= '/OrlaColegial' Component={OrlaColegial} />  
      <Route path= '/UsuariosAdmin' Component={UsuariosAdmin} />  
      <Route path= '/ComunicadosOficiales' Component={ComunicadosOficiales} />  
      <Route path= '/PaseComidas' Component={PaseComidas} />  
      <Route path= '/Mensajeria' Component={Mensajeria} />  
      <Route path= '/Notificaciones' Component={Notificaciones} />  
      <Route path= '/AjustesAdmin' Component={AjustesAdmin} />  
    </Routes>
    </BrowserRouter>
  );
}

export default App;
